module.exports = __webpack_public_path__ + "static/media/Mushroom_v1_500.5a8d0860.png";